import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            用户热评
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            真实观众分享观影体验，看看大家都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <article
              key={comment.id}
              className="bg-background-100 rounded-xl p-5 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>

              <div className="flex items-center gap-1 mb-3">
                {[...Array(comment.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>

              <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-4">
                {comment.content}
              </p>

              <div className="pt-3 border-t border-background-200/70">
                <span className="inline-flex items-center gap-1 text-xs text-primary-500 font-medium">
                  <i className="ri-movie-2-line"></i>
                  正在看《{comment.show}》
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}